import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.assign.js";
import Drip from 'drip';
import axios from 'axios';
import newAxios from '@/common/axios.mobile.js';
import Url from 'drip/utils/url';
import { ajaxPreUrl, dealAjaxPreUrl, ajaxNewMwebPreUrl, ajaxMwebMarketingPreUrl } from '@/config';
import { COMMENT_PROJECT_HOTCOMMENT } from '@/apis/index';
export { getkugouMusicList } from '../kugou-music/index';
import { transformDetailData } from './transform-data';
import { formatNewWebRes } from '@/utils';

// ajax请求前缀
var ajaxNewPreUrl = ajaxPreUrl.replace('/myshow/', '/myshowquestion/');

// 获取详情页演出数据
export var getDetail = /*#__PURE__*/function () {
  var _getDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(performanceId, params) {
    var uuid, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          localStorage.removeItem('latestProjectStrategy');
          _context.next = 3;
          return Drip.getUuid();
        case 3:
          uuid = _context.sent;
          _context.next = 6;
          return axios({
            url: "".concat(ajaxPreUrl, "/v2/performance/").concat(performanceId),
            method: 'get',
            params: params || {},
            headers: {
              'Content-type': 'application/json',
              'uuid': uuid
            }
          });
        case 6:
          res = _context.sent;
          return _context.abrupt("return", res);
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  function getDetail(_x, _x2) {
    return _getDetail.apply(this, arguments);
  }
  return getDetail;
}();
export var getDetailNew = /*#__PURE__*/function () {
  var _getDetailNew = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(performanceId, params) {
    var uuid, url, reqParams, res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          localStorage.removeItem('latestProjectStrategy');
          _context2.next = 3;
          return Drip.getUuid();
        case 3:
          uuid = _context2.sent;
          url = "".concat(ajaxNewMwebPreUrl, "/project/detail"); // 审核前预览接口
          if (params && params.previewKey) {
            url = "".concat(url, "/preview");
          }
          reqParams = Object.assign({}, params, {
            projectId: performanceId,
            detailType: '1'
          });
          _context2.next = 9;
          return axios({
            url: url,
            method: 'get',
            params: reqParams,
            headers: {
              'Content-type': 'application/json',
              'uuid': uuid
            }
          });
        case 9:
          res = _context2.sent;
          return _context2.abrupt("return", transformDetailData(res));
        case 11:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  function getDetailNew(_x3, _x4) {
    return _getDetailNew.apply(this, arguments);
  }
  return getDetailNew;
}();
export var getServerTime = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var url, res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          // 服务器时间获取
          url = "".concat(ajaxNewMwebPreUrl, "/serverTime");
          _context3.next = 3;
          return axios({
            url: url,
            method: 'get',
            params: {},
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 3:
          res = _context3.sent;
          return _context3.abrupt("return", res);
        case 5:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return function getServerTime() {
    return _ref.apply(this, arguments);
  };
}();

// 获取用户行为策略
export var getUserBehaviorStrategy = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(performanceId) {
    var url, reqParams, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          url = "".concat(ajaxMwebMarketingPreUrl, "/userBehaviorStrategy/queryStrategy");
          reqParams = {
            projectId: performanceId
          };
          _context4.next = 4;
          return axios({
            url: url,
            method: 'get',
            params: reqParams,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 4:
          res = _context4.sent;
          return _context4.abrupt("return", res);
        case 6:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return function getUserBehaviorStrategy(_x5) {
    return _ref2.apply(this, arguments);
  };
}();

// 领取优惠券
export var getUserBehaviorCoupon = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(performanceId, strategyId, strategyRuleId) {
    var _Drip$UA, _Drip$UA2;
    var uuid, fingerprint, version, clientType, url, reqParams, res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return Drip.getUuid();
        case 2:
          uuid = _context5.sent;
          _context5.next = 5;
          return Drip.getFingerprint();
        case 5:
          fingerprint = _context5.sent;
          version = (_Drip$UA = Drip.UA) === null || _Drip$UA === void 0 ? void 0 : _Drip$UA.appVersion;
          clientType = (_Drip$UA2 = Drip.UA) === null || _Drip$UA2 === void 0 ? void 0 : _Drip$UA2.osName;
          url = "".concat(ajaxMwebMarketingPreUrl, "/userBehaviorStrategy/completeStrategy");
          reqParams = {
            projectId: performanceId,
            strategyId: strategyId,
            strategyRuleId: strategyRuleId,
            riskRequest: {
              uuid: uuid,
              version: version,
              fingerprint: fingerprint,
              clientType: clientType
            }
          };
          _context5.next = 12;
          return axios({
            url: url,
            method: 'post',
            data: reqParams,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 12:
          res = _context5.sent;
          return _context5.abrupt("return", res);
        case 14:
        case "end":
          return _context5.stop();
      }
    }, _callee5);
  }));
  return function getUserBehaviorCoupon(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();

// 获取详情页推荐列表
export var getRecommends = /*#__PURE__*/function () {
  var _getRecommends = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(performanceId) {
    var uuid, res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) switch (_context6.prev = _context6.next) {
        case 0:
          uuid = Drip.constant.uuid || ''; // const res = await axios.get( `${ajaxPreUrl}/performances/0;st=4;p=1;s=11;tft=0` )
          _context6.next = 3;
          return axios.get("".concat(ajaxPreUrl, "/performance/recommends/").concat(performanceId, "?pageSource=1&source=3"));
        case 3:
          res = _context6.sent;
          return _context6.abrupt("return", res);
        case 5:
        case "end":
          return _context6.stop();
      }
    }, _callee6);
  }));
  function getRecommends(_x9) {
    return _getRecommends.apply(this, arguments);
  }
  return getRecommends;
}();
//获取团购
export var getGroupBuyApi = function getGroupBuyApi(projectId) {
  return axios.get("/groupPurchase?projectId=".concat(projectId));
};

// 获取项目的收藏状态
export var getCollectState = /*#__PURE__*/function () {
  var _getCollectState = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(performanceId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/newFavor/loadFavor?favorType=1&favorId=").concat(performanceId));
        case 2:
          res = _context7.sent;
          return _context7.abrupt("return", res);
        case 4:
        case "end":
          return _context7.stop();
      }
    }, _callee7);
  }));
  function getCollectState(_x10) {
    return _getCollectState.apply(this, arguments);
  }
  return getCollectState;
}();

// 收藏项目
export var addCollect = /*#__PURE__*/function () {
  var _collect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(performanceId) {
    var collectQueryParams, _Drip$User, _Drip$User3, _Drip$UA3, _Drip$UA4, _Drip$User2, _window$AppData, _window$AppData$$wall, _window$AppData2, _window$AppData2$$wec, res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) switch (_context8.prev = _context8.next) {
        case 0:
          // 猫眼微信 H5 接口需要 appId
          collectQueryParams = {};
          _context8.prev = 1;
          if ((_Drip$User = Drip.User) !== null && _Drip$User !== void 0 && _Drip$User.openId) {
            _context8.next = 5;
            break;
          }
          _context8.next = 5;
          return (_Drip$User2 = Drip.User) === null || _Drip$User2 === void 0 ? void 0 : _Drip$User2.getUserInfo();
        case 5:
          collectQueryParams = {
            wxOpenId: (_Drip$User3 = Drip.User) === null || _Drip$User3 === void 0 ? void 0 : _Drip$User3.openId
          };

          // 微信钱包小程序 渠道：7
          if ((_Drip$UA3 = Drip.UA) !== null && _Drip$UA3 !== void 0 && _Drip$UA3.IS_WXAPP_WALLET) {
            collectQueryParams.wxAppId = (_window$AppData = window.AppData) === null || _window$AppData === void 0 ? void 0 : (_window$AppData$$wall = _window$AppData.$wallet) === null || _window$AppData$$wall === void 0 ? void 0 : _window$AppData$$wall.appId;
          }

          // 微信小程序 渠道：6
          if ((_Drip$UA4 = Drip.UA) !== null && _Drip$UA4 !== void 0 && _Drip$UA4.IS_MAOYAN_WECHAT) {
            collectQueryParams.wxAppId = (_window$AppData2 = window.AppData) === null || _window$AppData2 === void 0 ? void 0 : (_window$AppData2$$wec = _window$AppData2.$wechat) === null || _window$AppData2$$wec === void 0 ? void 0 : _window$AppData2$$wec.appId;
          }
          _context8.next = 12;
          break;
        case 10:
          _context8.prev = 10;
          _context8.t0 = _context8["catch"](1);
        case 12:
          _context8.next = 14;
          return axios({
            url: "".concat(ajaxPreUrl, "/newFavor/addFavor"),
            method: 'post',
            data: {
              favorType: 1,
              favorId: performanceId,
              avatarUrl: Drip.constant.avatarURL || ''
            },
            params: collectQueryParams,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 14:
          res = _context8.sent;
          return _context8.abrupt("return", res);
        case 16:
        case "end":
          return _context8.stop();
      }
    }, _callee8, null, [[1, 10]]);
  }));
  function collect(_x11) {
    return _collect.apply(this, arguments);
  }
  return collect;
}();

// 取消收藏项目
export var cancelCollect = /*#__PURE__*/function () {
  var _delCollect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(performanceId) {
    var collectQueryParams, _Drip$User4, _Drip$User6, _Drip$UA5, _Drip$UA6, _Drip$User5, _window$AppData3, _window$AppData3$$wal, _window$AppData4, _window$AppData4$$wec, res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) switch (_context9.prev = _context9.next) {
        case 0:
          // 猫眼微信 H5 接口需要 appId
          collectQueryParams = {};
          _context9.prev = 1;
          if ((_Drip$User4 = Drip.User) !== null && _Drip$User4 !== void 0 && _Drip$User4.openId) {
            _context9.next = 5;
            break;
          }
          _context9.next = 5;
          return (_Drip$User5 = Drip.User) === null || _Drip$User5 === void 0 ? void 0 : _Drip$User5.getUserInfo();
        case 5:
          collectQueryParams = {
            wxOpenId: (_Drip$User6 = Drip.User) === null || _Drip$User6 === void 0 ? void 0 : _Drip$User6.openId
          };

          // 微信钱包小程序 渠道：7
          if ((_Drip$UA5 = Drip.UA) !== null && _Drip$UA5 !== void 0 && _Drip$UA5.IS_WXAPP_WALLET) {
            collectQueryParams.wxAppId = (_window$AppData3 = window.AppData) === null || _window$AppData3 === void 0 ? void 0 : (_window$AppData3$$wal = _window$AppData3.$wallet) === null || _window$AppData3$$wal === void 0 ? void 0 : _window$AppData3$$wal.appId;
          }

          // 微信小程序 渠道：6
          if ((_Drip$UA6 = Drip.UA) !== null && _Drip$UA6 !== void 0 && _Drip$UA6.IS_MAOYAN_WECHAT) {
            collectQueryParams.wxAppId = (_window$AppData4 = window.AppData) === null || _window$AppData4 === void 0 ? void 0 : (_window$AppData4$$wec = _window$AppData4.$wechat) === null || _window$AppData4$$wec === void 0 ? void 0 : _window$AppData4$$wec.appId;
          }
          _context9.next = 12;
          break;
        case 10:
          _context9.prev = 10;
          _context9.t0 = _context9["catch"](1);
        case 12:
          _context9.next = 14;
          return axios({
            url: "".concat(ajaxPreUrl, "/newFavor/cancelFavor"),
            method: 'post',
            data: {
              favorType: 1,
              favorId: performanceId,
              avatarUrl: Drip.constant.avatarURL || ''
            },
            params: collectQueryParams,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 14:
          res = _context9.sent;
          return _context9.abrupt("return", res);
        case 16:
        case "end":
          return _context9.stop();
      }
    }, _callee9, null, [[1, 10]]);
  }));
  function delCollect(_x12) {
    return _delCollect.apply(this, arguments);
  }
  return delCollect;
}();

// 获取m站预览跳转平台
export var getMsitePlaforms = /*#__PURE__*/function () {
  var _getMsitePlaforms = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(performanceId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/v2/performance/").concat(performanceId, "/canSellChannelList"));
        case 2:
          res = _context10.sent;
          return _context10.abrupt("return", res);
        case 4:
        case "end":
          return _context10.stop();
      }
    }, _callee10);
  }));
  function getMsitePlaforms(_x13) {
    return _getMsitePlaforms.apply(this, arguments);
  }
  return getMsitePlaforms;
}();

// 获取m站预览跳转二维码
export var getQRCode = /*#__PURE__*/function () {
  var _getMsitePlaforms2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(width, path, pid, utm) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) switch (_context11.prev = _context11.next) {
        case 0:
          _context11.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/boostTask/boostShareQRCodeImage?width=").concat(width, "&page=").concat(encodeURIComponent(path), "&scene=").concat(encodeURIComponent("id=".concat(pid, "&utm_source=").concat(utm)), "&appId=wxdbb4c5f1b8ee7da1"));
        case 2:
          res = _context11.sent;
          return _context11.abrupt("return", res);
        case 4:
        case "end":
          return _context11.stop();
      }
    }, _callee11);
  }));
  function getMsitePlaforms(_x14, _x15, _x16, _x17) {
    return _getMsitePlaforms2.apply(this, arguments);
  }
  return getMsitePlaforms;
}();

// 提交开售提醒
export var submitRemind = /*#__PURE__*/function () {
  var _submitRemind = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) switch (_context12.prev = _context12.next) {
        case 0:
          if (params) {
            params.avatarUrl = Drip.constant.avatarURL || '';
          }
          _context12.next = 3;
          return axios.post("".concat(ajaxPreUrl, "/messagepush/save"), params);
        case 3:
          res = _context12.sent;
          return _context12.abrupt("return", res);
        case 5:
        case "end":
          return _context12.stop();
      }
    }, _callee12);
  }));
  function submitRemind(_x18) {
    return _submitRemind.apply(this, arguments);
  }
  return submitRemind;
}();

// 提交开售提醒 新接口 详情页
export var submitRemindDetailNew = /*#__PURE__*/function () {
  var _submitRemindDetailNew = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) switch (_context13.prev = _context13.next) {
        case 0:
          if (params) {
            params.avatarUrl = Drip.constant.avatarURL || '';
          }
          _context13.next = 3;
          return axios.post("".concat(ajaxNewMwebPreUrl, "/project/detail/reserveReminder"), params);
        case 3:
          res = _context13.sent;
          return _context13.abrupt("return", res);
        case 5:
        case "end":
          return _context13.stop();
      }
    }, _callee13);
  }));
  function submitRemindDetailNew(_x19) {
    return _submitRemindDetailNew.apply(this, arguments);
  }
  return submitRemindDetailNew;
}();

// 根据id获取演出的场次信息

export var getShowInfo = /*#__PURE__*/function () {
  var _getShowInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) switch (_context14.prev = _context14.next) {
        case 0:
          _context14.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/v2/performance/").concat(id, "/shows/1"));
        case 2:
          res = _context14.sent;
          return _context14.abrupt("return", res);
        case 4:
        case "end":
          return _context14.stop();
      }
    }, _callee14);
  }));
  function getShowInfo(_x20) {
    return _getShowInfo.apply(this, arguments);
  }
  return getShowInfo;
}();
export var getAreaInfo = /*#__PURE__*/function () {
  var _getAreaInfo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) switch (_context15.prev = _context15.next) {
        case 0:
          res = axios.get("".concat(ajaxPreUrl, "/show/").concat(id, "/areas"));
          return _context15.abrupt("return", res);
        case 2:
        case "end":
          return _context15.stop();
      }
    }, _callee15);
  }));
  function getAreaInfo(_x21) {
    return _getAreaInfo.apply(this, arguments);
  }
  return getAreaInfo;
}();
export var getIsNeedAnswer = /*#__PURE__*/function () {
  var _getIsNeedAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          res = axios.get("".concat(dealAjaxPreUrl, "/question/queryQuestions?performanceId=").concat(id, "&count=3"));
          return _context16.abrupt("return", res);
        case 2:
        case "end":
          return _context16.stop();
      }
    }, _callee16);
  }));
  function getIsNeedAnswer(_x22) {
    return _getIsNeedAnswer.apply(this, arguments);
  }
  return getIsNeedAnswer;
}();

// 获取新答题
export var getIsNeedAnswerNew = /*#__PURE__*/function () {
  var _getIsNeedAnswerNew = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(id, answerFlag) {
    var res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) switch (_context17.prev = _context17.next) {
        case 0:
          res = axios.get("".concat(ajaxNewPreUrl, "/question/needAnswer?performanceId=").concat(id, "&count=3&answerFlag=").concat(answerFlag));
          return _context17.abrupt("return", res);
        case 2:
        case "end":
          return _context17.stop();
      }
    }, _callee17);
  }));
  function getIsNeedAnswerNew(_x23, _x24) {
    return _getIsNeedAnswerNew.apply(this, arguments);
  }
  return getIsNeedAnswerNew;
}();

// 预约公示相关
export var getReminderNumber = /*#__PURE__*/function () {
  var _getReminderNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(id) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) switch (_context18.prev = _context18.next) {
        case 0:
          res = axios.get("".concat(ajaxPreUrl, "/project/reserveNum/").concat(id));
          return _context18.abrupt("return", res);
        case 2:
        case "end":
          return _context18.stop();
      }
    }, _callee18);
  }));
  function getReminderNumber(_x25) {
    return _getReminderNumber.apply(this, arguments);
  }
  return getReminderNumber;
}();

// 预约公示相关
// export const getReminderNumberPost = async function getReminderNumber ( params ) {
//   const res = axios.post( `${ajaxPreUrl}/project/detail/reserve/num`, params )
//   return res
// }

export var checkActivityPermission = /*#__PURE__*/function () {
  var _checkActivityPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(checkParams) {
    var isNewMode,
      data,
      res,
      _args19 = arguments;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) switch (_context19.prev = _context19.next) {
        case 0:
          isNewMode = _args19.length > 1 && _args19[1] !== undefined ? _args19[1] : false;
          data = {};
          if (isNewMode) {
            if (checkParams.performanceId) data.projectId = checkParams.performanceId;
            if (checkParams.salt) data.salt = checkParams.salt;
            if (checkParams.openId) data.thirdUserId = checkParams.openId;
            if (checkParams.validationMessage) data.signature = checkParams.validationMessage;
            if (checkParams.isStressTest) data.isStressTest = checkParams.isStressTest;
            if (checkParams.eventType) data.eventCode = checkParams.eventType;
            if (checkParams.eventId) data.eventId = checkParams.eventId;
          } else {
            data = Object.assign({}, checkParams);
          }
          _context19.next = 5;
          return axios({
            url: isNewMode ? "".concat(ajaxNewMwebPreUrl, "/event/qualification/validate") : "".concat(ajaxPreUrl, "/token/validate"),
            method: 'post',
            data: data,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 5:
          res = _context19.sent;
          if (isNewMode) {
            _context19.next = 8;
            break;
          }
          return _context19.abrupt("return", res);
        case 8:
          return _context19.abrupt("return", formatNewWebRes(res));
        case 9:
        case "end":
          return _context19.stop();
      }
    }, _callee19);
  }));
  function checkActivityPermission(_x26) {
    return _checkActivityPermission.apply(this, arguments);
  }
  return checkActivityPermission;
}();
export var getFbfgOrderRecords = /*#__PURE__*/function () {
  var _getFbfgOrderRecords = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(pid, roundId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee20$(_context20) {
      while (1) switch (_context20.prev = _context20.next) {
        case 0:
          _context20.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/prepay/getQueueInfo?projectId=").concat(pid, "&roundId=").concat(roundId));
        case 2:
          res = _context20.sent;
          return _context20.abrupt("return", res);
        case 4:
        case "end":
          return _context20.stop();
      }
    }, _callee20);
  }));
  function getFbfgOrderRecords(_x27, _x28) {
    return _getFbfgOrderRecords.apply(this, arguments);
  }
  return getFbfgOrderRecords;
}();
export var checkFbfgPermission = /*#__PURE__*/function () {
  var _checkFbfgPermission = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(checkParams) {
    var res;
    return _regeneratorRuntime.wrap(function _callee21$(_context21) {
      while (1) switch (_context21.prev = _context21.next) {
        case 0:
          _context21.next = 2;
          return axios({
            url: "".concat(dealAjaxPreUrl, "/prepay/getAuthor"),
            method: 'post',
            data: Object.assign({}, checkParams),
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 2:
          res = _context21.sent;
          return _context21.abrupt("return", res);
        case 4:
        case "end":
          return _context21.stop();
      }
    }, _callee21);
  }));
  function checkFbfgPermission(_x29) {
    return _checkFbfgPermission.apply(this, arguments);
  }
  return checkFbfgPermission;
}();

// 活动权限校验
export var validateActivity = /*#__PURE__*/function () {
  var _validateActivity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(pid) {
    var res;
    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
      while (1) switch (_context22.prev = _context22.next) {
        case 0:
          _context22.next = 2;
          return axios.get("".concat(ajaxPreUrl, "/privilege/activity/validateMessage?projectId=").concat(pid));
        case 2:
          res = _context22.sent;
          return _context22.abrupt("return", res);
        case 4:
        case "end":
          return _context22.stop();
      }
    }, _callee22);
  }));
  function validateActivity(_x30) {
    return _validateActivity.apply(this, arguments);
  }
  return validateActivity;
}();

// 活动权限校验-新上单
export var validateActivityNew = /*#__PURE__*/function () {
  var _validateActivityNew = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(pid) {
    var res;
    return _regeneratorRuntime.wrap(function _callee23$(_context23) {
      while (1) switch (_context23.prev = _context23.next) {
        case 0:
          _context23.next = 2;
          return axios.get("".concat(ajaxNewMwebPreUrl, "/privilege/activity/validateMessage?projectId=").concat(pid));
        case 2:
          res = _context23.sent;
          return _context23.abrupt("return", formatNewWebRes(res));
        case 4:
        case "end":
          return _context23.stop();
      }
    }, _callee23);
  }));
  function validateActivityNew(_x31) {
    return _validateActivityNew.apply(this, arguments);
  }
  return validateActivityNew;
}();

// 校验是否通过LOL账号绑定校验
export var validateLOL = /*#__PURE__*/function () {
  var _validateLOL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(performanceId) {
    var isNewMode,
      data,
      res,
      _args24 = arguments;
    return _regeneratorRuntime.wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          isNewMode = _args24.length > 1 && _args24[1] !== undefined ? _args24[1] : false;
          data = isNewMode ? {
            projectId: performanceId
          } : {
            performanceId: performanceId
          };
          _context24.next = 4;
          return axios({
            url: isNewMode ? "".concat(ajaxNewMwebPreUrl, "/event/qualification/validate") : "".concat(ajaxPreUrl, "/token/validate"),
            method: 'post',
            data: data,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 4:
          res = _context24.sent;
          if (isNewMode) {
            _context24.next = 7;
            break;
          }
          return _context24.abrupt("return", res);
        case 7:
          return _context24.abrupt("return", formatNewWebRes(res));
        case 8:
        case "end":
          return _context24.stop();
      }
    }, _callee24);
  }));
  function validateLOL(_x32) {
    return _validateLOL.apply(this, arguments);
  }
  return validateLOL;
}();

// 优惠券领取
export var batchApply = /*#__PURE__*/function () {
  var _batchApply = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          _context25.next = 2;
          return axios({
            url: "".concat(dealAjaxPreUrl, "/performance/applyDiscountBatch"),
            method: 'post',
            data: Object.assign({}, params),
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 2:
          res = _context25.sent;
          return _context25.abrupt("return", res);
        case 4:
        case "end":
          return _context25.stop();
      }
    }, _callee25);
  }));
  function batchApply(_x33) {
    return _batchApply.apply(this, arguments);
  }
  return batchApply;
}();

// 获取热门评论列表
export var getHotComment = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26(params) {
    var res;
    return _regeneratorRuntime.wrap(function _callee26$(_context26) {
      while (1) switch (_context26.prev = _context26.next) {
        case 0:
          _context26.next = 2;
          return newAxios.get(COMMENT_PROJECT_HOTCOMMENT, {
            params: params
          });
        case 2:
          res = _context26.sent;
          return _context26.abrupt("return", res);
        case 4:
        case "end":
          return _context26.stop();
      }
    }, _callee26);
  }));
  return function getHotComment(_x34) {
    return _ref4.apply(this, arguments);
  };
}();

// 收藏项目
export var statsPvReport = /*#__PURE__*/function () {
  var _statsPvReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee27$(_context27) {
      while (1) switch (_context27.prev = _context27.next) {
        case 0:
          _context27.next = 2;
          return axios({
            url: "".concat(ajaxPreUrl, "/ad/stat/save"),
            method: 'post',
            data: payload,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 2:
          res = _context27.sent;
          return _context27.abrupt("return", res);
        case 4:
        case "end":
          return _context27.stop();
      }
    }, _callee27);
  }));
  function statsPvReport(_x35) {
    return _statsPvReport.apply(this, arguments);
  }
  return statsPvReport;
}();

// 查看项目主办
export var getPublicByProject = /*#__PURE__*/function () {
  var _getPublicByProject = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28(projectId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee28$(_context28) {
      while (1) switch (_context28.prev = _context28.next) {
        case 0:
          _context28.next = 2;
          return axios({
            url: "".concat(ajaxNewMwebPreUrl, "/publicity/detail?projectId=").concat(projectId),
            method: 'get',
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 2:
          res = _context28.sent;
          return _context28.abrupt("return", res);
        case 4:
        case "end":
          return _context28.stop();
      }
    }, _callee28);
  }));
  function getPublicByProject(_x36) {
    return _getPublicByProject.apply(this, arguments);
  }
  return getPublicByProject;
}();
export var getShareQrCode = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(url) {
    var res;
    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
      while (1) switch (_context29.prev = _context29.next) {
        case 0:
          _context29.prev = 0;
          _context29.next = 3;
          return axios({
            url: "".concat(ajaxPreUrl, "/tx/image/getUrlQrcodeLink"),
            method: 'get',
            params: {
              logoType: 0,
              url: url
            },
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 3:
          res = _context29.sent;
          return _context29.abrupt("return", res);
        case 7:
          _context29.prev = 7;
          _context29.t0 = _context29["catch"](0);
          return _context29.abrupt("return", null);
        case 10:
        case "end":
          return _context29.stop();
      }
    }, _callee29, null, [[0, 7]]);
  }));
  return function getShareQrCode(_x37) {
    return _ref5.apply(this, arguments);
  };
}();
export var getProjectDetail = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(orderId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee30$(_context30) {
      while (1) switch (_context30.prev = _context30.next) {
        case 0:
          _context30.prev = 0;
          _context30.next = 3;
          return axios({
            url: "".concat(ajaxPreUrl, "/tx/orderpay/queryOrderSharePageInfo"),
            method: 'get',
            params: {
              orderId: orderId
            },
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 3:
          res = _context30.sent;
          return _context30.abrupt("return", res);
        case 7:
          _context30.prev = 7;
          _context30.t0 = _context30["catch"](0);
          return _context30.abrupt("return", null);
        case 10:
        case "end":
          return _context30.stop();
      }
    }, _callee30, null, [[0, 7]]);
  }));
  return function getProjectDetail(_x38) {
    return _ref6.apply(this, arguments);
  };
}();

// 详情页来源上报
export var sourcePvReport = /*#__PURE__*/function () {
  var _sourcePvReport = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(payload) {
    var res;
    return _regeneratorRuntime.wrap(function _callee31$(_context31) {
      while (1) switch (_context31.prev = _context31.next) {
        case 0:
          _context31.next = 2;
          return axios({
            url: "".concat(ajaxNewMwebPreUrl, "/visit/source/save"),
            method: 'post',
            data: payload,
            headers: {
              'Content-type': 'application/json'
            }
          });
        case 2:
          res = _context31.sent;
          return _context31.abrupt("return", res);
        case 4:
        case "end":
          return _context31.stop();
      }
    }, _callee31);
  }));
  function sourcePvReport(_x39) {
    return _sourcePvReport.apply(this, arguments);
  }
  return sourcePvReport;
}();